<bp-alert-messages [src]="errors">
	<ng-template let-error>
		{{ error.message }}
		<small *ngIf="error.type && showType">{{ error.type }}</small>
	</ng-template>
</bp-alert-messages>
